import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

import Permissions from 'Components/Permissions'

const RugCardDetailedHeader = ({ rug }) => (
  <Card.Content>
    <Card.Meta>{rug.id}</Card.Meta>

    <Card.Header>{rug.name}</Card.Header>

    {rug.description && (
      <Permissions permissions="rug.field.description" render={() => <Card.Description>{rug.description}</Card.Description>} />
    )}
  </Card.Content>
)

RugCardDetailedHeader.propTypes = {
  rug: PropTypes.object.isRequired,
}

export default RugCardDetailedHeader
